"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ContractFilter = _interopRequireDefault(require("./components/ContractFilter"));
var _UploadFileUtil = _interopRequireDefault(require("@/views/mixin/UploadFileUtil"));
var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));
var _auth = require("@/utils/auth");
var _timeUtil = require("@/utils/time-util");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ContractFilter: _ContractFilter.default
  },
  mixins: [_UploadFileUtil.default, _FirebaseStorageUtil.default],
  data: function data() {
    return {
      fileList: []
    };
  },
  computed: {
    clients_contract: function clients_contract() {
      return this.$store.getters.clients_contract;
    },
    currentPage: function currentPage() {
      return this.$store.getters.page_doc_top;
    },
    maxPage: function maxPage() {
      return this.$store.getters.page_doc_last;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setClientID)(this.$route.params.id);
            }
            _context.next = 1;
            return this.$store.dispatch('client/setPageTop', 0);
          case 1:
            _context.next = 2;
            return this.$store.dispatch('client/fetchClientsContract', (0, _auth.getClientID)());
          case 2:
            _context.next = 3;
            return (0, _appUtil.checkReadingFlag)(true);
          case 3:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 4;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    goToDetail: function goToDetail(id) {
      return this.$router.push({
        name: 'ContractDetail',
        params: {
          id: id
        }
      });
    },
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    },
    displayexpiration_date: function displayexpiration_date(date_of_acceptance, format) {
      if (date_of_acceptance !== null) {
        var expiration_date = new Date(date_of_acceptance);
        expiration_date.setDate(expiration_date.getDate() + 5);
        this.expiration_date = expiration_date;
        return this.displayDateTime(expiration_date, format);
      }
      return this.displayDateTime(date_of_acceptance, format);
    },
    displayAcceptanceType: function displayAcceptanceType(val, date_of_acceptance) {
      if (val === _DocumentCategory.DocumentCategory.Acceptance.TRUE.val) {
        return _DocumentCategory.DocumentCategory.Acceptance.TRUE.label;
      }
      if (date_of_acceptance !== null) {
        return _DocumentCategory.DocumentCategory.Acceptance.CANCEL.label;
      }
      return _DocumentCategory.DocumentCategory.Acceptance.FALSE.label;
    },
    goTopPage: function () {
      var _goTopPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return this.$store.dispatch('client/setPageTop', 0);
            case 1:
              _context3.next = 2;
              return this.$store.dispatch('client/fetchClientsContract', (0, _auth.getClientID)());
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function goTopPage() {
        return _goTopPage.apply(this, arguments);
      }
      return goTopPage;
    }(),
    goPrePage: function () {
      var _goPrePage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var pre;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.$store.dispatch('client/getPageTop');
            case 1:
              pre = _context4.sent;
              if (!(pre > 0)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 2;
              return this.$store.dispatch('client/setPageTop', pre - 1);
            case 2:
              _context4.next = 3;
              return this.$store.dispatch('client/fetchClientsContract', (0, _auth.getClientID)());
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function goPrePage() {
        return _goPrePage.apply(this, arguments);
      }
      return goPrePage;
    }(),
    goNextPage: function () {
      var _goNextPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var next, last, _t3;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return this.$store.dispatch('client/getPageTop');
            case 1:
              next = _context5.sent;
              _t3 = Math;
              _context5.next = 2;
              return this.$store.dispatch('client/getPageLast');
            case 2:
              last = _t3.floor.call(_t3, _context5.sent);
              if (!(last > next)) {
                _context5.next = 4;
                break;
              }
              _context5.next = 3;
              return this.$store.dispatch('client/setPageTop', next + 1);
            case 3:
              _context5.next = 4;
              return this.$store.dispatch('client/fetchClientsContract', (0, _auth.getClientID)());
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function goNextPage() {
        return _goNextPage.apply(this, arguments);
      }
      return goNextPage;
    }(),
    goLastPage: function () {
      var _goLastPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var last, _t4;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _t4 = Math;
              _context6.next = 1;
              return this.$store.dispatch('client/getPageLast');
            case 1:
              last = _t4.floor.call(_t4, _context6.sent);
              _context6.next = 2;
              return this.$store.dispatch('client/setPageTop', last);
            case 2:
              _context6.next = 3;
              return this.$store.dispatch('client/fetchClientsContract', (0, _auth.getClientID)());
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function goLastPage() {
        return _goLastPage.apply(this, arguments);
      }
      return goLastPage;
    }()
  }
};